import { get, post } from '../utils/axios'
//course
export const getTraningAPI = async () => {
  return await get('training/list/course')
}
//expire
export const getTrainingListExpStatusAPI = async () => {
  return await get('training/list/exp/status')
}
//status (active, inactive)
export const getTrainingStatusActiveAPI = async () => {
  return await get('training/list/detail/status')
}
//yesorno
export const getTrainingListExpireAPI = async () => {
  return await get('training/list/expire')
}
//level
export const getTrainingListLevelAPI = async () => {
  return await get('training/list/level')
}
//brand
export const getTrainingListPartnerAPI = async () => {
  return await get('training/list/partner')
}
//position
export const getTrainingListPositionAPI = async () => {
  return await get('training/list/position')
}
//product
// export const getTrainingListProductAPI = async () => {
//   return await get('training/list/product')
// }
//test pass or no
export const getTrainingListStatusAPI = async () => {
  return await get('training/list/status')
}
//get ใหญ่
export const getTrainingListAPI = async (param) => {
  return await get('training/list', param)
}


export const getTrainingAPI = async (param) => {
  return await get('training/get', param)
}

export const postTrainingAPI = async (body) => {
  return await post('training/create', body)
}

export const updateTrainingAPI = async (body) => {
  return await post('training/update', body)
}

export const deleteTrainingAPI = async (body) => {
  return await post('training/cancel', body)
}
//delete
export const deleteTrainingsAPI = async (body) => {
  return await post('training/delete', body)
}

//create file training
export const postTraingFileAPI = async (body) => {
  return await post('training/create/file', body)
}
//get file
export const getTraingFileAPI = async (param) => {
  return await get('training/get/file', param)
}

//percent
export const getPercentAPI = async () => {
  return await get('profiles/get/per')
}

//percent
export const getCetificateHaveAPI = async (param) => {
  return await get('training/get/have/status', param)
}